// extracted by mini-css-extract-plugin
export var blue = "_47-g";
export var brand = "_47-c";
export var darkGrey = "_47-f";
export var disabled = "_47-5";
export var disabledSubtle = "_47-6";
export var error = "_47-7";
export var green = "_47-h";
export var grey = "_47-e";
export var icon = "_47-0";
export var inherit = "_47-b";
export var lightGrey = "_47-d";
export var orange = "_47-j";
export var pink = "_47-l";
export var primary = "_47-1";
export var purple = "_47-m";
export var quaternary = "_47-4";
export var red = "_47-k";
export var secondary = "_47-2";
export var success = "_47-a";
export var tertiary = "_47-3";
export var warning = "_47-8";
export var warningSecondary = "_47-9";
export var white = "_47-n";
export var yellow = "_47-i";